import { lazyLoad } from 'app/utils/loadable';

export const ServicesPage = lazyLoad(
  () => import('./services-page'),
  (module) => module.ServicesPage
);
